import React from "react";
import { ScheduleContext } from "./ScheduleContext";
import { useProvideScheduleData } from "./scheduleData";

export function ScheduleProvider({ children }: { children: React.ReactNode }) {
  const value = useProvideScheduleData();
  return <ScheduleContext.Provider value={value}>{children}</ScheduleContext.Provider>;
}

export default ScheduleProvider;
